import React from 'react';

const PricingPlans = () => {
  return (
    <section className="py-20 px-4 bg-white" id='precios'>
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-[#03ADED]">Planes a tu medida</h2>
        
        <div className="h-1 w-20 bg-[#03ADED] mx-auto my-6"></div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Plan Básico */}
          <div className="border-2 border-gray-300 rounded-xl p-6 relative">
            <span className="absolute -top-2.5 -right-2.5 bg-red-500 text-white px-3 py-1 text-xs font-bold rounded-bl-lg rounded-tr-lg">Nuevo</span>
            <h3 className="text-xl font-semibold text-gray-600">⚪ Plan Básico</h3>
            <p className="mt-2 text-gray-600">Para quienes recién empiezan y necesitan lo esencial.</p>
            <p className="text-sm text-gray-400"><del>Antes: S/ 300</del></p>
            <p className="text-4xl font-bold text-gray-600 my-2">S/ 250 <span className="text-sm">pago anual</span></p>
            
            <div className="mt-4 space-y-2">
              <p className="flex items-center">✔ Registro de ventas</p>
              <p className="flex items-center">✔ Control básico de stock</p>
              <p className="flex items-center">✔ 1 usuario</p>
              <p className="flex items-center">✔ 1 almacén</p>
              <p className="flex items-center">✔ 1 subdominio incluido</p>
              <p className="flex items-center">✔ Reportes básicos</p>
              <p className="flex items-center text-gray-400">✖ Sin impresión de tickets</p>
              <p className="flex items-center text-gray-400">✖ Sin personalización</p>
            </div>
          </div>

          {/* Plan Emprendedor (Más popular) */}
          <div className="border-2 border-[#03ADED] rounded-xl p-6 bg-gray-50 relative transform scale-105 z-10 shadow-lg">
            <span className="absolute -top-2.5 -right-2.5 bg-yellow-400 text-black px-3 py-1 text-xs font-bold rounded-bl-lg rounded-tr-lg">Más popular</span>
            <h3 className="text-xl font-semibold text-gray-800">🟣 Plan Emprendedor</h3>
            <p className="mt-2 text-gray-600">El favorito de quienes quieren crecer con tecnología.</p>
            <p className="text-sm text-gray-400"><del>Antes: S/ 699</del></p>
            <p className="text-5xl font-bold text-gray-800 my-2">S/ 549 <span className="text-sm">pago anual</span></p>
            
            <div className="mt-4 space-y-2">
              <p className="flex items-center">✔ Todo lo del Plan Básico</p>
              <p className="flex items-center">✔ Módulo de ventas con impresión de tickets</p>
              <p className="flex items-center">✔ Reportes avanzados de ventas</p>
              <p className="flex items-center">✔ Multi-almacén</p>
              <p className="flex items-center">✔ Hasta 3 usuarios</p>
              <p className="flex items-center">✔ Búsqueda por código de barras</p>
              <p className="flex items-center">✔ Subida masiva de productos</p>
              <p className="flex items-center">✔ Capacitación inicial gratis</p>
              <p className="flex items-center">✔ 1 subdominio incluido</p>
              <p className="flex items-center">✔ Soporte preferente vía WhatsApp</p>
            </div>
          </div>

          {/* Plan Pro Plus */}
          <div className="border-2 border-yellow-400 rounded-xl p-6 relative">
            <span className="absolute -top-2.5 -right-2.5 bg-red-500 text-white px-3 py-1 text-xs font-bold rounded-bl-lg rounded-tr-lg">20% DCTO</span>
            <h3 className="text-xl font-semibold text-yellow-600">🟡 Plan Pro Plus</h3>
            <p className="mt-2 text-gray-600">Para empresas que buscan máxima personalización y escalabilidad.</p>
            <p className="text-sm text-gray-400"><del>Antes: S/ 999</del></p>
            <p className="text-4xl font-bold text-yellow-600 my-2">S/ 799 <span className="text-sm">pago anual</span></p>
            
            <div className="mt-4 space-y-2">
              <p className="flex items-center">✔ Todo lo del Plan Emprendedor</p>
              <p className="flex items-center">✔ Hasta 6 usuarios</p>
              <p className="flex items-center">✔ Personalización visual (logo y colores)</p>
              <p className="flex items-center">✔ Personalización de dominio propio</p>
              <p className="flex items-center">✔ Facturación electrónica (SUNAT)</p>
              <p className="flex items-center">✔ Soporte prioritario</p>
              <p className="flex items-center">✔ Capacitación personalizada</p>
              <p className="flex items-center">✔ Subdominio o dominio personalizado</p>
            </div>
          </div>
        </div>

        <div className="bg-yellow-50 p-4 rounded-xl border border-yellow-200 mt-10 text-center  mx-auto">
          <p className="font-bold text-yellow-600">⚡ Importante: Equipos no incluidos</p>
          <p className="text-gray-600">
            El servicio incluye el sistema, hosting, subdominio y soporte. Los equipos (celulares, tablets, computadoras o impresoras) no están incluidos. 
            ¡Pero no te preocupes! Puedes usar cualquier dispositivo que ya tengas, y si necesitas ayuda para conseguir equipos, también te asesoramos sin compromiso.
          </p>
        </div>

        
      </div>
    </section>
  );
};

export default PricingPlans;